import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('glcwc-content-article', wrap(Vue, () => import('~root/./src/components/glcwc-content/Article.vue?shadow')))

window.customElements.define('glcwc-content-blog-post', wrap(Vue, () => import('~root/./src/components/glcwc-content/BlogPost.vue?shadow')))

window.customElements.define('glcwc-content-blog-post-list', wrap(Vue, () => import('~root/./src/components/glcwc-content/BlogPostList.vue?shadow')))

window.customElements.define('glcwc-content-comm-prod-list', wrap(Vue, () => import('~root/./src/components/glcwc-content/CommProdList.vue?shadow')))

window.customElements.define('glcwc-content-comm-product', wrap(Vue, () => import('~root/./src/components/glcwc-content/CommProduct.vue?shadow')))

window.customElements.define('glcwc-content-donation', wrap(Vue, () => import('~root/./src/components/glcwc-content/Donation.vue?shadow')))

window.customElements.define('glcwc-content-event', wrap(Vue, () => import('~root/./src/components/glcwc-content/Event.vue?shadow')))

window.customElements.define('glcwc-content-image-only', wrap(Vue, () => import('~root/./src/components/glcwc-content/ImageOnly.vue?shadow')))

window.customElements.define('glcwc-content-text-only', wrap(Vue, () => import('~root/./src/components/glcwc-content/TextOnly.vue?shadow')))